import { Pipe, PipeTransform } from '@angular/core';
import { OrderTypes } from '@next/core-lib/cart';
import { AllowedOrderRoles } from '@next/core-lib/models';

import { isItemTypeEligibleForCartType } from '../helpers/add-to-cart-helpers';
import { SkuCatalogItemViewData } from '../models/product.models';

@Pipe({ name: 'formatAddProductToCartButtonText', standalone: true })
export class FormatAddProductToCartButtonTextPipe implements PipeTransform {
  transform(
    catalogItem: SkuCatalogItemViewData,
    additionalInfo: {
      hasAtLeastAdvisorRole: boolean;
      cartType?: OrderTypes;
      useDefaultText?: boolean;
    },
  ): string {
    const defaultText = 'product.search.table.add-to-cart';
    if (additionalInfo.useDefaultText) {
      return defaultText;
    }

    if (!catalogItem?.orderingInformation || catalogItem.orderingInformation.allowedUsers === AllowedOrderRoles.none) {
      return 'product.search.table.not-available-in-shop';
    }

    if (catalogItem.orderingInformation.allowedUsers === AllowedOrderRoles.advisorsAndAbove && !additionalInfo.hasAtLeastAdvisorRole) {
      return 'product.search.table.contact-advisor';
    }

    if (!isItemTypeEligibleForCartType(catalogItem, additionalInfo.cartType)) {
      return 'product.search.table.not-eligible-for-carttype';
    }

    return defaultText;
  }
}
